export default function getScreenById(
  screenId: string,
  yamlObj: any
): any | null {
  if (!screenId || !yamlObj || !Array.isArray(yamlObj.pages)) return null;

  for (const page of yamlObj.pages) {
    if (!page || !Array.isArray(page.screens)) continue;

    for (const screen of page.screens) {
      if (screen && screen.id === screenId) {
        return screen;
      }
    }
  }

  return null;
}
